import { render, staticRenderFns } from "./TemplateMessageSetup.vue?vue&type=template&id=11452e93"
import script from "./TemplateMessageSetup.vue?vue&type=script&lang=js"
export * from "./TemplateMessageSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports